import { memo } from 'react';
const _Tick = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => <svg aria-hidden="true" className={className} fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props} data-sentry-element="svg" data-sentry-component="_Tick" data-sentry-source-file="Tick.tsx">
    <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" data-sentry-element="path" data-sentry-source-file="Tick.tsx" />
  </svg>;
const Tick = memo(_Tick);
export default Tick;